export default __webpack_public_path__ + "static/media/Pin-Completed.71641b93.svg";